import styled from "styled-components";

export const TabWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 30px;
`